import * as React from 'react';
import { Text } from '@lightspeed/flame/Text';

import { ReceiptCustomerWrapper } from './Receipt.style';

interface ReceiptCustomerProps {
  firstName: string | undefined;
}

const ReceiptCustomer: React.FunctionComponent<ReceiptCustomerProps> = ({ firstName }) =>
  firstName ? (
    <ReceiptCustomerWrapper data-testid="receipt-customer">
      <Text color="gray-800" size="large">
        {firstName}
      </Text>
    </ReceiptCustomerWrapper>
  ) : null;

export default ReceiptCustomer;
